import { render, staticRenderFns } from "./PageAddressSelect.vue?vue&type=template&id=cde034c2"
import script from "./PageAddressSelect.vue?vue&type=script&lang=js"
export * from "./PageAddressSelect.vue?vue&type=script&lang=js"
import style0 from "./PageAddressSelect.vue?vue&type=style&index=0&id=cde034c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports